import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowRight } from 'lucide-react';
import { partnerAPI } from '../services/api';
import { getImageUrl } from '../config/runtime';

/**
 * "More adventures from <venue>" — shown on session pages whose project was
 * cloned from a partner-owned starter. Closes the Scan-to-Play loop: instead
 * of dead-ending in generic app-land after a tour, the visitor is pointed
 * back into the venue's branded world (/p/:slug).
 */
const VenueBacklink = ({ originalProjectId }) => {
  const { data } = useQuery({
    queryKey: ['partner-by-starter', originalProjectId],
    queryFn: () => partnerAPI.getByStarter(originalProjectId),
    enabled: Boolean(originalProjectId),
    staleTime: 60 * 60 * 1000, // venue ownership basically never changes mid-session
    retry: false,
  });

  const partner = data?.data?.data?.partner;
  if (!partner) return null;

  return (
    <Link
      to={`/p/${partner.slug}`}
      className="flex items-center gap-3 rounded-2xl bg-emerald-50 dark:bg-emerald-500/10 ring-1 ring-emerald-200 dark:ring-emerald-500/20 hover:ring-emerald-300 dark:hover:ring-emerald-500/40 px-4 py-3 transition-all group"
    >
      {partner.logoUrl && (
        <img
          src={getImageUrl(partner.logoUrl)}
          alt=""
          className="w-8 h-8 rounded-lg object-contain bg-white flex-shrink-0"
        />
      )}
      <span className="text-sm text-emerald-800 dark:text-emerald-300 min-w-0 flex-1">
        More adventures from <span className="font-semibold">{partner.name}</span>
      </span>
      <ArrowRight
        size={16}
        className="text-emerald-500 flex-shrink-0 group-hover:translate-x-0.5 transition-transform"
      />
    </Link>
  );
};

export default VenueBacklink;
